import './scss/style.scss'
import 'intl-tel-input/build/css/intlTelInput.css'

// Swiper CSS
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'
import 'swiper/css/thumbs'

// Libs internas
import DisableScroll from './js/lib/disable-scroll'
import Forms from './js/lib/forms'
import UtmHandler from './js/lib/utmHandler'

window.dataLayer = []
const documentTitle = document.title.slice(2, -12)

/**
 * Obtener cookie por nombre
 */
function getCookie (name) {
  const dc = document.cookie
  const prefix = `${name}=`
  let begin = dc.indexOf(`; ${prefix}`)

  if (begin === -1) {
    begin = dc.indexOf(prefix)
    if (begin !== 0) return null
  } else {
    begin += 2
  }

  let end = dc.indexOf(';', begin)
  if (end === -1) end = dc.length

  return decodeURI(dc.substring(begin + prefix.length, end))
}

const gaCookie = getCookie('_ga')

if (gaCookie) {
  window.dataLayer.push({
    page_name: documentTitle
  })
}

window.throttle = (callback, wait = 100) => {
  let timer = null

  return function (...args) {
    if (timer === null) {
      timer = setTimeout(() => {
        callback.apply(this, args)
        timer = null
      }, wait)
    }
  }
}

window.addEventListener('load', () => {
  window.ajaxReq = function ajaxReq () {
    if (window.XMLHttpRequest) {
      return new XMLHttpRequest() // eslint-disable-line no-undef
    } else if (window.ActiveXObject) {
      return new ActiveXObject('Microsoft.XMLHTTP') // eslint-disable-line no-undef
    } else {
      // eslint-disable-next-line no-console
      console.log('Browser does not support XMLHTTP.')
      return false
    }
  }

  window.loadJS = (() => {
    const callbacks = {}
    const loaded = {}

    return (file, callback) => {
      if (callbacks[file]) {
        if (!loaded[file]) {
          callbacks[file].push(callback)
        } else {
          callback()
        }
        return
      }

      callbacks[file] = [callback]

      const jsElm = document.createElement('script')
      jsElm.type = 'application/javascript'
      jsElm.src = file

      jsElm.addEventListener('load', () => {
        loaded[file] = true
        callbacks[file].forEach(cb => typeof cb === 'function' && cb())
      })

      document.body.appendChild(jsElm)
    }
  })()

  window.disableScroll = new DisableScroll()

  const RecaptchaScript = new Forms()
  RecaptchaScript.loadScript()

  UtmHandler.setup()
})
